import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;
const clientApiUrl = process.env.REACT_APP_CLIENT_API_URL;

const DatasetAPI = {
	getCutPoints: () => {
		return axios
			.get(`${apiUrl}/datasets/cutpoints`)
			.then((response) => response.data as CutPointDTO[]);
	},
	getOrganizationDatasets: (
		organizationId: number,
		includeUserCount = false,
		includeLocationCount = false,
		userId: number = 0
	) => {
		const queryString = `?includeUserCount=${includeUserCount}&includeLocationCount=${includeLocationCount}&userId=${userId}`;
		return axios
			.get(`${apiUrl}/organizations/${organizationId}/datasets` + queryString)
			.then((response) => response.data as DatasetDTO[]);
	},
	getOrganizationDataset: (organizationId: number, datasetId: number) => {
		return axios
			.get(`${apiUrl}/organizations/${organizationId}/datasets/${datasetId}`)
			.then((response) => response.data as DatasetDTO);
	},
	getDatasetNames: (req: GetOrganizationDatasetNamesRequest) => {
		return axios
			.get(
				`${apiUrl}/organizations/${req.organizationId}/datasets/dataset-names`
			)
			.then((res) => res.data as string[]);
	},
	getDatasetLanguages: (req: GetDatasetLanguagesRequest) => {
		return axios
			.get(
				`${apiUrl}/organizations/${req.organizationId}/datasets/${req.datasetId}/languages`
			)
			.then((response) => response.data as PickListItemResponseDTO[]);
	},
	getDatasetVehicleTypes: (req: GetDatasetVehicleTypesRequest) => {
		return axios
			.get(
				`${apiUrl}/organizations/${req.organizationId}/datasets/${req.datasetId}/vehicle-types`
			)
			.then((response) => response.data as PickListItemResponseDTO[]);
	},
	getOrganizationDatasetReportSettings: (
		organizationId: number,
		datasetId: number
	) => {
		return axios
			.get(
				`${apiUrl}/organizations/${organizationId}/datasets/${datasetId}/report-settings`
			)
			.then((response) => response.data as ReportSettingDTO);
	},
	upsertOrganizationDataset: (
		organizationId: number,
		datasetDetails: UpsertDatasetRequest
	) => {
		return axios
			.post(
				`${apiUrl}/organizations/${organizationId}/datasets`,
				datasetDetails
			)
			.then((response) => response.data as DatasetDTO);
	},
	upsertOrganizationDatasetReportSetting: (
		organizationId: number,
		datasetId: number,
		reportSetting: UpsertDatasetReportSettingRequest
	) => {
		return axios
			.post(
				`${apiUrl}/organizations/${organizationId}/datasets/${datasetId}/report-settings`,
				reportSetting
			)
			.then((response) => response.data as ReportSettingDTO);
	},
	getOrganizationDatasetUsers: (organizationId: number, datasetId: number) => {
		return axios
			.get(
				`${apiUrl}/organizations/${organizationId}/datasets/${datasetId}/users`
			)
			.then((response) => response.data as DatasetUserDTO[]);
	},
	postOrganizationDatasetUser: (
		organizationId: number,
		userInfo: DatasetUserDTO
	) => {
		return axios
			.post(
				`${apiUrl}/organizations/${organizationId}/datasets/${userInfo.datasetId}/users`,
				userInfo
			)
			.then((response) => response.status);
	},
	deleteOrganizationDatasetUser: (deleteUser: DeleteDatasetUserRequest) => {
		return axios
			.post(
				`${apiUrl}/organizations/${deleteUser.organizationId}/datasets/${deleteUser.datasetId}/users/${deleteUser.userId}`,
				deleteUser
			)
			.then((response) => response.status);
	},
	// client site methods
	getClientSiteOrganizationDatasets: (
		organizationId: number,
		include?: string
	) => {
		const includeString = include === undefined ? "" : "?include=" + include;
		return axios
			.get(
				`${clientApiUrl}/organizations/${organizationId}/datasets` +
					includeString
			)
			.then((response) => response.data as DatasetDTO[]);
	},
	getClientSiteOrgniazationDatasetsForClient: (
		organizationId: number,
		clientId: number,
		include?: string
	) => {
		const includeString = include === undefined ? "" : "?include=" + include;
		return axios
			.get(
				`${clientApiUrl}/organizations/${organizationId}/client/${clientId}/datasets` +
					includeString
			)
			.then((response) => response.data as DatasetDTO[]);
	},
	getClientSiteOrganizationDataset: (
		organizationId: number,
		datasetId: number
	) => {
		return axios
			.get(
				`${clientApiUrl}/organizations/${organizationId}/datasets/${datasetId}`
			)
			.then((response) => response.data as DatasetDTO);
	},
};

export default DatasetAPI;
